import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const createCountry = async (data: CreateCountryReqT) =>
  axios.post(Routes.CREATE_COUNTRY, data);

export const useCreateCountry = () =>
  useMutation({
    mutationKey: [Keys.CREATE_COUNTRY_MUT],
    mutationFn: createCountry,
  });
